import { WidgetType } from 'common/schema/widget/Widget';
import { WidgetInputType } from 'common/schema/widget/input/WidgetInputType';
import { WidgetGraphicType } from 'common/schema/widget/graphic/WidgetGraphic';
import { WidgetDynamicType } from 'common/schema/widget/dynamic/WidgetDynamic';

type WidgetTypeOptionInput = {
  type: WidgetType.Input;
  label: string;
  subtype: WidgetInputType;
};

type WidgetTypeOptionGraphic = {
  type: WidgetType.Graphic;
  label: string;
  subtype: WidgetGraphicType;
};

type WidgetTypeOptionDynamic = {
  type: WidgetType.Dynamic;
  label: string;
  subtype: WidgetDynamicType;
};

export type WidgetTypeOption =
  | WidgetTypeOptionInput
  | WidgetTypeOptionGraphic
  | WidgetTypeOptionDynamic;

interface IWidgetTypeOptionsGrouped {
  inputs: WidgetTypeOption[];
  graphics: WidgetTypeOption[];
  dynamics: WidgetTypeOption[];
}

/**
 * Raggruppate, per la visualizzazione come `OptGroup`
 */
export const WidgetTypeOptionsGrouped: IWidgetTypeOptionsGrouped = {
  inputs: [
    {
      label: 'Input di Testo',
      type: WidgetType.Input,
      subtype: WidgetInputType.Text
    },
    {
      label: 'Input Numerico',
      type: WidgetType.Input,
      subtype: WidgetInputType.Numeric
    },
    {
      label: 'Input Email',
      type: WidgetType.Input,
      subtype: WidgetInputType.Email
    },
    {
      label: 'Input Valuta',
      type: WidgetType.Input,
      subtype: WidgetInputType.Currency
    },
    {
      label: 'Input di Scelta Singola',
      type: WidgetType.Input,
      subtype: WidgetInputType.SingleChoice
    },
    {
      label: 'Input di Scelta a Cascata',
      type: WidgetType.Input,
      subtype: WidgetInputType.CascadeSelect
    },
    {
      label: 'Input di Scelta Multipla',
      type: WidgetType.Input,
      subtype: WidgetInputType.MultipleChoice
    },
    {
      label: 'Input di Preferenza Multipla',
      type: WidgetType.Input,
      subtype: WidgetInputType.MultiPreference
    },
    {
      label: 'Input Data',
      type: WidgetType.Input,
      subtype: WidgetInputType.Date
    },
    {
      label: 'Input Intervallo di Date',
      type: WidgetType.Input,
      subtype: WidgetInputType.DateInterval
    },
    // {
    //   label: 'Input Indirizzo',
    //   type: WidgetType.Input,
    //   subtype: WidgetInputType.Address
    // },
    {
      label: 'Input Provincia e Comune',
      type: WidgetType.Input,
      subtype: WidgetInputType.Region
    },
    {
      label: 'Input Upload File',
      type: WidgetType.Input,
      subtype: WidgetInputType.File
    },
    {
      label: 'Lista di Input',
      type: WidgetType.Input,
      subtype: WidgetInputType.List
    },
    {
      label: 'Input Booleano',
      type: WidgetType.Input,
      subtype: WidgetInputType.Boolean
    },
    {
      label: 'Captcha',
      type: WidgetType.Input,
      subtype: WidgetInputType.Captcha
    },
    {
      label: 'Anteprima Documento',
      type: WidgetType.Input,
      subtype: WidgetInputType.Preview
    },
    {
      label: 'Anteprima Documento e Upload Documento Firmato',
      type: WidgetType.Input,
      subtype: WidgetInputType.UploadSigned
    }
  ],
  graphics: [
    {
      label: 'Testo Libero',
      type: WidgetType.Graphic,
      subtype: WidgetGraphicType.Text
    },
    {
      label: 'Titolo',
      type: WidgetType.Graphic,
      subtype: WidgetGraphicType.Section
    },
    {
      label: 'Nota Informativa',
      type: WidgetType.Graphic,
      subtype: WidgetGraphicType.Info
    },
    {
      label: 'Divisore Sezione',
      type: WidgetType.Graphic,
      subtype: WidgetGraphicType.Divider
    }
  ],
  dynamics: [
    {
      label: 'Campo Dinamico',
      type: WidgetType.Dynamic,
      subtype: WidgetDynamicType.Dynamic
    },
    {
      label: 'Campo Calcolato',
      type: WidgetType.Dynamic,
      subtype: WidgetDynamicType.Computed
    }
  ]
};

/**
 * Versione in un'unico array
 */
export const WidgetTypeOptions = [
  ...WidgetTypeOptionsGrouped.inputs,
  ...WidgetTypeOptionsGrouped.graphics,
  ...WidgetTypeOptionsGrouped.dynamics
];

export function getWidgetTypeOption(subtype: WidgetTypeOption['subtype']) {
  return WidgetTypeOptions.find(option => option.subtype === subtype)!;
}
